export default "__VITE_ASSET__BjsOK10i__"